<app-header></app-header><div class="container">
  <div class="breadcrumbs mt-4">
    <div routerLink="/">Главная</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/tekhnicheskoe-diagnostirovanie/">Техническое освидетельствование опасных производственных объектов: технических устройств, зданий и сооружений
    </div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/tekhnicheskoe-diagnostirovanie/obsledovanie-gpm/">Техническое освидетельствование кранов и грузоподъемных сооружений




    </div>
  </div>
  <div class="row">
    <h1 class="w-100 mt-70">Техническое освидетельствование кранов и грузоподъемных сооружений
    </h1>
    <ul class="link-arrow">
      <li>- Освидетельствование подъемников и других грузоподъемных средств</li>
      <li>- В Москве и регионах</li>
      <li>- Полное соблюдение заявленных сроков</li>
      <li>- Собственная ЛНК</li>
    </ul>

    <p class="mt-4">Согласно <strong>ст.9 Федерального закона от 21.07.1997 № 116-ФЗ &quot;О промышленной безопасности опасных производственных объектов&quot;</strong>, в обязанности организации, эксплуатирующей опасный производственный объект, <strong>входит проведение диагностики, испытаний и освидетельствования технических устройств, в том числе техническое освидетельствование</strong> грузоподъемных механизмов, применяемых на ОПО, в установленные сроки и/или по предписанию федерального органа исполнительной власти.</p>

    <div>
      <p>Согласно<strong> Федеральным нормам и правилам в области промышленной безопасности, утвержденным Приказом Ростехнадзора от 26.11.2020 № 461</strong>, грузоподъемные механизмы, на которые распространяются вышеуказанные ФНП, должны подвергаться техническому обследованию и освидетельствованию до ввода их в работу и в процессе эксплуатации в объеме и порядке, указанном в инструкции на грузоподъемное сооружение.</p>
    </div>

    <h2>Специалисты ООО &laquo;Протос Экспертиза&raquo;:</h2>

    <ul class="marked ml-50">
      <li>проведут техническое диагностирование подъемных сооружений и освидетельствование автокрана, талей, люлек и других ГПМ;</li>
      <li>подготовят результаты (заключение) диагностики;</li>
      <li>проведут экспертизу промышленной безопасности;</li>
      <li>дадут разъяснения по всем этапам освидетельствования и ЭПБ;</li>
    </ul>

    <p>Стоимость зависит от класса опасности ОПО, от признаков опасности, от объема выполняемых работ и рассчитывается индивидуально.</p>
    <app-recall-form heading="У Вас есть вопрос? Наши специалисты Вас проконсультируют."></app-recall-form>
    <p>Согласно Приказу Ростехнадзора от 26.11.2020 № 461, техническое диагностирование кранов и прочих грузоподъемных механизмов включает в себя:</p>

      <ul class="marked ml-50">
        <li>частичное техническое освидетельствование крана, которое необходимо проводить не реже 1 раза в год;</li>
        <li>полное техническое освидетельствование, которое проводится 1 раз в три года (кроме освидетельствования ГМП, которые подлежат обследованию не реже 1 раза в 5 лет, используемых для обслуживания машинных залов, электрических станций, насосных станций, компрессорного оборудования, в том числе для ремонта устройств и установок и пр.).</li>
        <li>внеочередное техническое освидетельствование, которое проводится в случае модернизации, капитального ремонта, замены грузозахватного устройства и пр.</li>
      </ul>

      <p><strong>При полном техническом освидетельствовании</strong> грузоподъемные механизмы подвергаются осмотру и испытаниям (статическим, динамическим, на устойчивость и пр.), в том числе с применением методов неразрушающего контроля.</p>

      <p><strong>При частичном освидетельствовании</strong> проводить статические и/или динамические испытания не требуется.</p>

      <p>По завершении освидетельствования в паспорт ГМП вносится соответствующая отметка с указанием срока проведения следующего обследования. В случае несоответствия грузоподъемного механизма и отрицательного результата осмотра &ndash; составляется акт, отражающий выявленные несоответствия.</p>

    <p><strong>Наши эксперты работают в области промышленной безопасности более 20 лет, регулярно повышают свою квалификацию и отлеживают изменения в нормативных и законодательных актах. Доверьте проведение технического освидетельствования и диагностирования грузоподъемных механизмов, применяемых на Вашем ОПО, специалистам &laquo;ООО Протос Экспертиза&raquo;. Мы проведем все обследования в соответствии с Федеральными нормами и правилами в области промышленной безопасности.&nbsp;</strong></p>
    <app-recall-form heading="Нет времени изучать детали? Напишите Ваш вопрос - и наши специалисты Вас проконсультируют."></app-recall-form>
    <h2>Справочная информация:</h2>

    <p><strong>Для обеспечения выполнения требований к промышленной безопасности -организация, использующая грузоподъемные устройства, должна руководствоваться</strong> Федеральными нормами и правилами в области промышленной безопасности &quot;Правила безопасности опасных производственных объектов, на которых используются подъемные сооружения&quot;, утвержденными приказом Федеральной службы по экологическому, технологическому и атомному надзору от 26 ноября 2020 года № 461.</p>

    <h2>Вышеуказанные ФНП распространяются на:</h2>

    <ul class="marked ml-50">
      <li>грузоподъемные краны любого типа;</li>
      <li>краны-штабелеры мостового типа;</li>
      <li>краны-трубоукладчики;</li>
      <li>краны-манипуляторы;</li>
      <li>строительные подъемные устройства и механизмы;</li>
      <li>подъемные механизмы и устройства (вышки) для перемещения людей и груза, в том числе с рабочими платформами;</li>
      <li>рельсовые пути и электротележки (включая кабины управления), используемые для передвижения по ним;</li>
      <li>тали электрические;</li>
      <li>краны-экскаваторы, в том числе для работы с крюком;</li>
      <li>грузозахватные устройства для перемещения грузов;</li>
      <li>грузовая тара (кроме механизмов, применяемых в морских и речных портах);</li>
      <li>люльки и кабины для перемещения и подъема людей.&nbsp;</li>
    </ul>

    <div>
      <p><strong>Федеральные нормы и правила в области промышленной безопасности &quot;Правила безопасности опасных производственных объектов, на которых используются подъемные сооружения&quot; применяются на протяжении всех циклов использования грузоподъемных механизмов и сопутствующих устройств.</strong></p>
    </div>
    <app-atomka-calc heading="Получить консультацию эксперта и последующий расчет стоимости технического освидетельствования"></app-atomka-calc>
    <app-reviews-block class="w-100"></app-reviews-block>
  </div>
</div>
<app-footer></app-footer>
